import { Box, Heading, Text, useColorModeValue, useToast, VStack } from '@chakra-ui/react';
import CustomButton from 'components/CustomButton';
import React, { useRef, useState } from 'react';
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile';
import { BsBuilding } from 'react-icons/bs';
import { startOnboarding } from 'services/api.service';
import { FaPerson } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

const FirstPage: React.FC = () => {
  const textColor = useColorModeValue('brandText.700', 'white');
  const textColorSecondary = 'gray.400';
  const navigate = useNavigate();
  const toast = useToast();
  const [turnstileToken, setTurnstileToken] = useState<string | undefined>();
  const turnstileRef = useRef<TurnstileInstance>(null);
  const { isLoading, mutateAsync: startOnboardingRequest } = useMutation(['startOnboarding'], startOnboarding);

  const handleSubmitType = async (type: 'PF' | 'PJ') => {
    if (!turnstileToken) {
      toast({
        title: 'Aguarde',
        description: 'Aguarde o desafio de segurança ser concluído',
        status: 'warning',
        position: 'top',
      });
      return;
    }
    await startOnboardingRequest({ type, turnstileToken })
      .then((response) => {
        if (type === 'PF') {
          navigate(`/auth/register/holder?id=${response.id}`, {
            state: { id: response.id },
          });
        } else {
          navigate(`/auth/register/company?id=${response.id}`);
        }
      })
      .catch(() => {
        turnstileRef.current?.reset();
        setTurnstileToken(undefined);
      });
  };

  return (
    <Box w="full" alignItems="center" display="flex" flexDirection="column">
      <Heading color={textColor} fontSize="24px" mb="10px" mt={10}>
        Cadastre-se!
      </Heading>
      <Text mb="36px" ms="4px" color={textColorSecondary} fontWeight="400" fontSize="md">
        Selecione o tipo de cadastro abaixo!
      </Text>
      <VStack w="100%" spacing={4} height="100%" mb={'200px'}>
        <CustomButton
          leftIcon={<FaPerson />}
          variant="solid"
          isLoading={isLoading}
          onClick={() => handleSubmitType('PF')}
        >
          Pessoa Física
        </CustomButton>
        <CustomButton
          leftIcon={<BsBuilding />}
          variant="solid"
          isLoading={isLoading}
          onClick={() => handleSubmitType('PJ')}
        >
          Pessoa Jurídica
        </CustomButton>
        <Turnstile
          ref={turnstileRef}
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY as string}
          onSuccess={setTurnstileToken}
          onExpire={() => setTurnstileToken(undefined)}
          onError={() => {
            setTurnstileToken(undefined);
            toast({
              title: 'Erro',
              description: 'Erro no desafio de segurança. Tente novamente.',
              status: 'error',
              duration: 5000,
              position: 'top',
              isClosable: true,
            });
          }}
          options={{ action: 'ONBOARDING_CUSTOMER' }}
        />
      </VStack>
    </Box>
  );
};

export default FirstPage;
